/**
 * ERP Connection — system identifier constants (SEE-683+).
 *
 * Mirrors the Python `ERPSystem` enum in speedchain-cdk
 * (src/shared/v2CommonTools/libs/enums/erp_system.py). The slug values
 * intentionally match what's already in `app/services/agave/agaveConstants`
 * (`AgaveSourceSystem`) — ERPConnection.erpType stores the same strings
 * Agave's `agaveSourceSystemSlug` does — so downstream consumers can
 * compare against either set without translation.
 *
 * No imports from `app/services/agave/*` — this module belongs to the
 * direct-ERP integration namespace and stays clean of Agave references
 * to make SEE-878 cutover a clean delete of agaveConstants.
 */

export enum ErpSystem {
  ACUMATICA = 'acumatica',
  CMIC = 'cmic',
  QUICKBOOKS_DESKTOP = 'quick-books-desktop',
  QUICKBOOKS_ONLINE = 'quick-books-online',
  SAGE_100_CONTRACTOR = 'sage-100-contractor',
  SAGE_300_CRE = 'sage-300-cre',
  SAGE_INTACCT = 'sage-intacct',
  SPECTRUM = 'spectrum',
  VIEWPOINT_VISTA_HOSTED = 'vista-hosted',
}
